import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import { useResolvedWorkspace } from './useWorkspaces'
import type { KpiSummaryResponse, KpiStatsResponse } from '@/types/api'

/**
 * KPI Summary を取得するフック
 * 提案採択率・無視率・再提案成功率・週次トレンドを返す
 */
export function useKpiSummary() {
  const { workspaceId } = useResolvedWorkspace(import.meta.env.VITE_DEFAULT_WORKSPACE_ID)
  return useQuery<KpiSummaryResponse>({
    queryKey: ['kpi', 'summary', workspaceId],
    queryFn: () => getApiClient().getKpiSummary(workspaceId),
    enabled: !!workspaceId,
    // 5分ごとに更新
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * KPI Stats を取得するフック
 * 日別・ステータス別・テンプレート別の統計を返す
 */
export function useKpiStats(period: 'week' | 'month' = 'week') {
  const { workspaceId } = useResolvedWorkspace(import.meta.env.VITE_DEFAULT_WORKSPACE_ID)
  return useQuery<KpiStatsResponse>({
    queryKey: ['kpi', 'stats', workspaceId, period],
    queryFn: () => getApiClient().getKpiStats(period, workspaceId),
    enabled: !!workspaceId,
    // 5分ごとに更新
    staleTime: 5 * 60 * 1000,
  })
}
